import {lazy} from 'react'

const AuthLoginScreen = lazy(
  () => import(/* webpackChunkName: 'AuthLogin' */ './AuthLoginScreen'),
)

export * from './AuthLoginScreen'
export {AuthLoginScreen}
